import React from "react";
import { Button, Divider } from "@src/components/atoms";
import { ColumnEditor } from "./ColumnEditor";

const colValueAvailable = (cols) => {
  let currentColValue = 0;
  for (let i = 0; i < cols.length; i++) {
    currentColValue += Number(cols[i].width);
  }
  return 4 - currentColValue;
};

export const RowEditor = (props) => {
  const {
    cols,
    index,
    sectionIndex,
    addCol,
    removeCol,
    removeRow,
    changeColWidth,
    changeColAlign,
    dataOptions,
    behaviourOptions,
    changeColGraph,
    changeColBehaviour,
    changeContentType,
    duplicateGraphs,
  } = props;
  const availableColValues = colValueAvailable(cols);
  const cantAddCols = availableColValues < 1;

  const handleAddCol = () => {
    console.log("add column");
    addCol(sectionIndex, index);
  };

  const handleRemoveRow = () => {
    removeRow(sectionIndex, index);
  };

  return (
    <div>
      <div className="flex">
        <div className="w-1/5">
          <Button disabled={cantAddCols} onClick={handleAddCol}>
            Add Column
          </Button>
          <Button color="red" onClick={handleRemoveRow}>
            Remove Row
          </Button>
        </div>
        {cols.map((col, idx) => (
          <ColumnEditor
            key={idx}
            behaviourCode={col.behaviourCode}
            data={col.data}
            width={col.width}
            align={col.align}
            contentType={col.contentType}
            removeCol={removeCol}
            sectionIndex={sectionIndex}
            rowIndex={index}
            colIndex={idx}
            changeWidth={changeColWidth}
            availableColValues={availableColValues}
            changeAlign={changeColAlign}
            dataOptions={dataOptions}
            behaviourOptions={behaviourOptions}
            changeGraph={changeColGraph}
            changeBehaviour={changeColBehaviour}
            changeContentType={changeContentType}
            duplicateGraphs={duplicateGraphs}
          />
        ))}
      </div>
      <Divider />
    </div>
  );
};
